import { render } from "./OTPModalControl.vue?vue&type=template&id=36afbd4e"
import script from "./OTPModalControl.vue?vue&type=script&lang=js"
export * from "./OTPModalControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__